import { render } from "./HousingComplex.vue?vue&type=template&id=24401d7e"
import script from "./HousingComplex.vue?vue&type=script&lang=js"
export * from "./HousingComplex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__